// seeder.js
var Seeder = pc.createScript('seeder');

Seeder.attributes.add('inputField', {type:'entity'});

// initialize code called once per entity
Seeder.prototype.initialize = function() {
    this.callAseed = new Math.seedrandom();
    this.seed = Math.random().toString();
    this.startSeed = this.seed;
    this.uniqeSeed = '0';
    this.app.on('systemGenerator:reSeed', this.reset, this);
    this.url = new URL(window.top.location.href);
    this.urlseed = this.url.searchParams.get('s');
    this.startUrl = false;
    this.firstTime = true;
    if(this.urlseed !== null){
        this.seed = this.urlseed;
    }
};

Seeder.prototype.reset = function(){
    if(this.inputField.script.input.getValue().length === 0){
        this.seed = Math.random().toString();
        this.app.fire('seeder:reset');
        this.inputField.script.input.setValue(this.seed);
        return;
    }
    
    if(this.inputField.script.input.getValue() == this.seed){
        this.seed = Math.random().toString();
        this.app.fire('seeder:reset');
        this.inputField.script.input.setValue(this.seed);
        return;
    } else if (this.inputField.script.input.getValue() != this.seed){
        this.seed = this.inputField.script.input.getValue().toString();
        this.app.fire('seeder:reset');
        this.inputField.script.input.setValue(this.seed);
        return;
    }
    if(this.firstTime){
        if(this.urlseed === null){
            this.firstTime = false;
            this.seed = this.startSeed;
        }
    }
    
};


Seeder.prototype.getUniqueRandom = function(){
    this.uniqeSeed = new Math.seedrandom(this.seed);
    if(this.uniqeSeed !== undefined){
        return this.uniqeSeed();
    }
};

// update code called every frame
Seeder.prototype.update = function(dt) {
  
};

// swap method called for script hot-reloading
// inherit your script state here
// Seeder.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

